<matchmaking-form-content [contentImage]="content().mappedImage">
  <matchmaking-form-option-list>
    <div
      class="options-container"
      [@expandCollapse]="getAnimation()"
      [class.show-all]="showAllOptions()"
      #formOptionElement>
      @for (option of visibleOptions(); track option; let last = $last) {
        <matchmaking-form-option
          class="form-option"
          data-cy="form-option"
          [option]="option"
          [isSelected]="option.title === selectedOption()"
          (setSelected)="setSelected($event)"
          [class.last.child]="last">
        </matchmaking-form-option>
      }

      <div
        [@childAnimation]="getAnimation()"
        class="extended-options-container"
        [class.is-open]="showAllOptions()">
        @for (option of hiddenOptions(); track option; let last = $last) {
          <matchmaking-form-option
            class="extended-option"
            #extendedOptions
            data-cy="form-option-children-hidden"
            [option]="option"
            [isSelected]="option.title === selectedOption()"
            (setSelected)="setSelected($event)"
            [class.last-child]="last">
          </matchmaking-form-option>
        }
      </div>
      @if (shouldShowShowMoreButton()) {
        <matchmaking-form-show-more-less-button
          data-cy="show-more-less-button"
          (toggler)="toggleShowAllOptions($event)">
        </matchmaking-form-show-more-less-button>
      }
    </div>
    <div class="buttons-container">
      <matchmaking-form-back-button
        (click)="handleBack()"
        [text]="translations()!.button.back"
        data-cy="back-button">
      </matchmaking-form-back-button>
      <matchmaking-form-submit-button
        data-cy="submit-button"
        [text]="translations()!.button.processDetails"
        [isDisabled]="!selectedOption()"
        (triggerSubmitEvent)="submit()">
      </matchmaking-form-submit-button>
    </div>
  </matchmaking-form-option-list>
</matchmaking-form-content>
